export const MENU_UY_THAC_QUAN_LY_DANH_MUC_DAU_TU = `20221015125511670`;
export const MENU_QUY_DAU_TU_CHUNG_KHOAN = `20221015125443995`;

// Về chúng tôi - Quan hệ cổ đông
export const MENU_CONG_BO_THONG_TIN = `20220914134211525`;
export const MENU_DAI_HOI_CO_DONG = `20220914134306529`;
export const MENU_TAI_LIEU_CONG_TY = `20220914134324034`;
// Sub menu
export const MENU_BAO_CAO_DINH_KY = `20220914134240606`;
export const MENU_BCDK_BAO_CAO_TAI_CHINH = `20221017171340725`;
export const MENU_BCDK_BAO_CAO_THUONG_NIEN = `20221017171403536`;
export const MENU_BCDK_BAN_CAO_HACH = `20221017171418481`;

// Về chúng tôi - Đội ngũ lãnh đạo
export const MENU_HOI_DONG_DAU_TU = `20220914134131755`;
export const MENU_BAN_LANH_DAO = `20220914134102778`;
